import { withRouter } from 'react-router-dom'

import FetchData from './FetchData'

export default withRouter(FetchData)
